import React, { useEffect, useMemo, useRef } from "react"
import PropTypes from "prop-types"
import { getBudgetProgress } from "../../../utils/clientReport.utils"
import ProgressBar from "../../../components/atoms/misc/ProgressBar.atom"
import { isBudgetTypeCredit } from "../../../utils/budget.utils"

const SprintBudgetConsumptionProgress = ({ data }) => {
  // const percentage = getBudgetProgress(data)
  const barRef = useRef(null)
  const minVisualWidth = 4
  const percentage = useMemo(() => {
    if (!data) return 0

    let value = 0

    if (isBudgetTypeCredit(data?.clientBudgetTypeId)) {
      if (data?.suggestedMonthlyBudgetLimit > 0) {
        // porcentaje consumido
        value =
          (data?.lastMonthBilledTime / data?.suggestedMonthlyBudgetLimit) * 100
      }
    } else {
      value = getBudgetProgress(data)
      value = value === "-" ? 0 : value
    }

    if (value === "-") return 0
    if (value < 0) return 0

    return value
  }, [data])

  useEffect(() => {
    if (barRef.current) {
      const element = barRef.current.getElement()
      const valueElement = element.querySelector(".p-progressbar-value")
      if (percentage <= 0) {
        valueElement.style.width = "100%"
        valueElement.style.backgroundColor =
          "light-dark(#d9d9d9, rgba(255, 255, 255, 0.1))"
        element.style.backgroundColor =
          "light-dark(#d9d9d9, rgba(255, 255, 255, 0.1))"
      } else {
        valueElement.style.width =
          percentage > 0 ? `${Math.max(percentage, minVisualWidth)}%` : "100%"
        valueElement.style.backgroundColor = "var(--primary-color)"
      }
    }
  }, [percentage])

  return (
    <div
      className="flex flex-column gap-2"
      style={{
        color: "light-dark(var(--secondary-color-dark), var(--text-color)",
      }}
    >
      <ProgressBar
        ref={barRef}
        style={{ height: "34px" }}
        value={percentage}
        color={"var(--primary-color)"}
        className="relative"
        displayValueTemplate={(value) => {
          return (
            <span
              className={Number(value) === 0 ? "clr-text" : ""}
              style={{
                position: "absolute",
                transform: "translate(-50%, -50%)",
                left: "50%",
                top: "50%",
              }}
            >
              {Math.trunc(percentage * 100) / 100}%
            </span>
          )
        }}
      />
    </div>
  )
}

export default SprintBudgetConsumptionProgress

SprintBudgetConsumptionProgress.propTypes = {
  data: PropTypes.shape({
    totalBudget: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    totalBilledTime: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    lastEightWeeksTruncatedMean: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  }),
}
